export const formatToIndianSystem = (number) => {
  const isLessThan100k = number <= 99999;
  const formatter = new Intl.NumberFormat('en-IN', {
    maximumSignificantDigits: 2,
    notation: isLessThan100k ? 'standard' : 'compact',
    compactDisplay: 'short',
  });
  if (isLessThan100k && number >= 1000) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  if (isLessThan100k) {
    return number.toString();
  }
  return formatter.format(number);
};
